var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcImagePlus32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27 6h1a1 1 0 1 1 0 2h-1v1a1 1 0 0 1-2 0V8h-1a1 1 0 1 1 0-2h1V5a1 1 0 0 1 2 0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M8 11.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M16.536 15.098a5 5 0 0 1 7.053 0l3.116 3.102a1 1 0 1 1-1.41 1.418l-3.117-3.102a3 3 0 0 0-4.232 0l-9.24 9.193a1 1 0 1 1-1.411-1.418z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 6a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h13a3 3 0 0 0 3-3v-9a1 1 0 1 1 2 0v9a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5h11.75a1 1 0 1 1 0 2z",
  clipRule: "evenodd"
})));
export default SvgIcImagePlus32;